import React from 'react'

export const AlertLevelWidget = ({ alertLevel }) => (
  <span className='AlertLevelWidget'>ALERT LEVEL {alertLevel}</span>
)

export default AlertLevelWidget
